/// <reference lib="dom" />
import * as d3 from "d3";
import type { ChartLayer, ChartScale } from "../core/chart.ts";
import { ScaleIn } from "./shared.ts";

export interface LineDatum {
  x: number;
  y: number;
}

export interface LineSeries {
  id: string;
  points: LineDatum[];
  color?: string;
  width?: number;
  opacity?: number;
  dashed?: boolean;
  step?: boolean;
  label?: string;
}

export interface LinesLayerOpts {
  id?: string;
  y?: ChartScale;
}

export interface LinesLayer extends ChartLayer {
  set(series: LineSeries[]): void;
}

export function LinesLayer(opts: LinesLayerOpts = {}): LinesLayer {
  let series: LineSeries[] = [];
  const line = d3.line<LineDatum>();
  return {
    id: opts.id ?? "lines",
    clip: true,
    set(next) {
      series = next;
    },
    render(root, ctx) {
      const y = ScaleIn(ctx, "y", opts.y);
      line.x((p) => ctx.x(p.x)).y((p) => y(p.y));
      root.selectAll<SVGPathElement, LineSeries>("path")
        .data(series, (s) => s.id)
        .join((enter) => enter.append("path").call((p) => p.append("title")))
        .attr("fill", "none")
        .attr("stroke", (s) => s.color ?? ctx.theme.series)
        .attr("stroke-width", (s) => s.width ?? ctx.theme.strokeWidth)
        .attr("stroke-opacity", (s) => s.opacity ?? 1)
        .attr("stroke-dasharray", (s) => (s.dashed ? "3,2" : null))
        .attr("stroke-linejoin", "round")
        .style("pointer-events", "none")
        .attr(
          "d",
          (s) =>
            s.points.length
              ? line.curve(s.step ? d3.curveStepAfter : d3.curveLinear)(s.points)
              : null,
        )
        .select("title")
        .text((s) => s.label ?? s.id);
    },
  };
}
